import * as React from "react";
const SvgPlus = props => <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M12 5V19M5 12H19" stroke="#141414" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" /></svg>;
export default SvgPlus;